import {html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {getLocallangText, formatNumber} from '../../swsRateCalculatorForm-init.mjs';

@customElement('sws-form-header')
export class SwsFormHeader extends LitElement {

    @property({type: Array})
    tabs: any[] = [];

    constructor() {
        super();
        this.tabs = [];
    }

    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('tariffs-current', this._updateTabs.bind(this));
        document.addEventListener('tariff-updated-temporary', this.handleTariffUpdatedTemporary.bind(this));
        document.addEventListener('tariff-deleted', this.deleteTariff.bind(this));
        document.addEventListener('removeTariffsFromFormHeader', this.removeTariffsFromFormHeader.bind(this));
    }

    private _updateTabs(e: CustomEvent) {
        const tariffs = e.detail as Tariff[];
        this.tabs = tariffs.map((tariff, index) => ({
            id: `tab-${index}`,
            title: tariff.tariff.title,
            data: tariff
        }));
        this.requestUpdate();
    }

    private removeTariffsFromFormHeader() {
        this.tabs = [];
        this.requestUpdate();
    }

    deleteTariff(e: CustomEvent) {
        this.tabs.forEach( (tab, index) => {
            if (tab.id === e.detail.tariffUid) {
                this.tabs.splice(index, 1); // Entferne den Tab
            }
        });

        this.requestUpdate();
    }

    handleTariffUpdatedTemporary(e: CustomEvent) {
        const updatedTariff = e.detail.updatedTariff;

        this.tabs.forEach( (tab, index) => {
            if(tab.id === e.detail.tariffUid) {
                this.tabs[index] = {
                    ...tab,
                    data: updatedTariff
                };
            }
        });

        this.requestUpdate();
    }


    private openModal(tariff: any) {

        const selectedTab = this.tabs.find(tab => tab.id === tariff.id);
        const event = new CustomEvent('set-tariff-data', {
            detail: {
                productType: Number(tariff.data.type),
                productName: tariff.title,
                tariffData: tariff.data,
                deliveryData: selectedTab?.deliveryData || null,
                selectedTabUid: selectedTab?.id,
            },
            bubbles: true,
            composed: true
        });
        document.dispatchEvent(event); // globale Event-Übertragung
    }

    protected createRenderRoot() {
        return this;
    }

    protected render() {

        return html`
            ${this.renderTariffList(this.tabs)}
            `
    }

    private renderTariffList(tabs: any[]) {
        this.requestUpdate();
        return html`${tabs.map((tariff, index) =>
                html`
            <div class="d-flex flex-row flex-wrap gx-md-4">
                <span><strong>${tariff.title}</strong></span>
                <span class="px-2 b1bbbe">•</span>
                <span>${TYPO3?.lang?.['form.formHeader.consumption.title']} <strong>${formatNumber(tariff.data.tariff.consumptionGeneral)} ${TYPO3?.lang?.['form.formHeader.consumption.kWH']}</strong></span>
                <span class="px-2 b1bbbe">•</span>
                <span>${TYPO3?.lang?.['form.formHeader.costs.title']} <strong>${formatNumber(tariff.data.tariff.price, 2)} € / ${TYPO3?.lang?.['form.formHeader.costs.month']}</strong></span>
                <span class="px-2 b1bbbe">•</span>
                <a class="text-black" href="#"
                   data-bs-toggle="modal"
                   data-bs-target="#modal-change-tariff"
                   @click=${() => this.openModal(tariff)}
                   aria-label="${getLocallangText("form.formHeader.customizeTariff.ariaLabel", [tariff.title])}">
                    ${TYPO3?.lang?.['form.formHeader.customizeTariff']}
                </a>
            </div>
        `)}
  `
    }}
